import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as jsonFooter from '../../../assets/config/footer.json';

// @ts-ignore
import { version } from '../../../../package.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public columns;
  public footerItems = jsonFooter.config;
  public appVersion: string;

  constructor(public translate: TranslateService, private _router: Router) {
  }

  public ngOnInit() {
    const currentYear = new Date().getFullYear();
    this.appVersion = `Version : ${currentYear} ${version}`;
  }

  showFooter() {
    return !this._router.url.includes('/avisdepublicite/creerAvisPub') && !this._router.url.includes('/avisdepublicite/editerAvisPub');
  }
}
